<template>
	<div class="mx-auto">
		<div class="mx-auto">
			<PresentationPlayer :selectedLanguage="selectedLanguage" :initialIframeSrc="viewUrl" />
		</div>
	</div>
</template>
<script setup lang="ts">
import { messages } from '@/assets/language';
import PresentationPlayer from '@/components/PresentationPlayer.vue';
import type { configCollectionMode } from '@/types';

const labels = computed(() => {
	const key = props.selectedLanguage as keyof typeof messages;
	return messages[key] ?? {};
});

const props = defineProps<{
	id: string,
	viewUrl?: string,
	editUrl?:string,
	selectedLanguage: string,
	collectionMode?: configCollectionMode | null;

}>();

watch(
	() => props.selectedLanguage,
	(newLang) => {
		if (newLang) {
			console.log(`Gjuha e re nga prindi: ${newLang}`);
		} else {
			console.log('Gjuha nuk është kaluar ende.');
		}
	}
);

</script>